import React from 'react';
import {NavLink} from 'react-router-dom';
import {Text} from '@chakra-ui/react';
import {LogoProps} from '../../interfaces/interfaces';

export default function Logo({_fontSize, _mt}: LogoProps) {
  return (
    <NavLink to="/" exact>
      <Text textAlign="center" mt={_mt} fontWeight={"extrabold"} fontSize={_fontSize}>
        <span style={{color: "#F59E0B"}}>Vid</span>
        <span>Com</span>
      </Text>
    </NavLink>
  )
}
